<template>
  <v-main class="tpadding">
    <v-chip @click="back()" color="blueKonect" medium text class="pa-4 mt-3 ml-3 mb-2 white--text">Atras</v-chip>
    <v-container fluid v-if="this.items">
      <v-card class="rounded-xl elevation-5">
        <v-toolbar v-if="this.konectVan.item" style="display: flex; justify-content: center" dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Detalle de viaje {{ "#" + this.konectVan.item.folio_orden_servicio }}</v-toolbar-title>
        </v-toolbar>
        <div v-if="loading">
          <v-skeleton-loader class="mx-auto" type="list-item-three-line, card, actions"></v-skeleton-loader>
        </div>
        <v-card-text v-else>
          <v-row no-gutters class="pb-4" style="justify-content: space-between; align-items: flex-end">
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 100%">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Resumen</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn elevation="0" text small @click="dialogs.map = true"> Ver Mapa <v-icon>mdi-map</v-icon> </v-btn>
                </v-toolbar>
                <div style="height: 150px; overflow: scroll; display: flex">
                  <div class="mt-2" style="width: 50%">
                    <v-card-title class="text-h6 py-1"> Turno: {{ this.items.turno_id }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Folio de viaje: {{ this.items.folio_viaje }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Estado de viaje: {{ this.items.estado_externo }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Tipo de viaje: {{ this.items.tipo_viaje }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Promedio de calificaciones: {{ this.items.promedio_calificacion ? this.items.promedio_calificacion : "" }} </v-card-title>
                  </div>
                  <div class="mt-2" style="width: 50%">
                    <v-card-title class="text-h6 py-1"> Fecha hora inicio: {{ this.items.fecha_inicio_plan }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Fecha hora fin: {{ this.items.fecha_fin_plan }}</v-card-title>
                    <v-card-title class="text-h6 py-1"> Ocupación mínima: {{ this.items.pasajeros_minimos }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Ocupación máxima: {{ this.items.pasajeros_maximos }} </v-card-title>
                    <v-card-title class="text-h6 py-1"> Pasajeros totales: {{ this.items.total_pasajeros }} </v-card-title>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 250px; overflow: scroll">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Unidad</v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-h6 py-1"> Placas: {{ this.items.vehiculo ? this.items.vehiculo.placas : "" }} </v-card-title>
                <v-card-title class="text-h6 py-1"> Número económico: {{ this.items.vehiculo ? this.items.vehiculo.numero_economico : "" }} </v-card-title>
                <v-card-title class="text-h6 py-1"> Capacidad: {{ this.items.vehiculo ? this.items.vehiculo.capacidad : "" }} </v-card-title>
                <v-card-title class="text-h6 py-1"> Marca: {{ this.items.vehiculo ? this.items.vehiculo.marca_chasis : "" }} </v-card-title>
                <v-card-title class="text-h6 py-1"> Modelo: {{ this.items.vehiculo ? this.items.vehiculo.marca_carroceria : "" }} </v-card-title>
                <v-card-title class="text-h6 py-1"> Año: {{ this.items.vehiculo ? this.items.vehiculo.modelo_chasis : "" }} </v-card-title>

                <v-card-actions style="display: flex; flex-direction: column; align-items: flex-start">
                  <v-btn small center outlined color="blueKonect" class="ma-auto mx-3 mb-3" elevation="0" @click="showTarget()"> Tarjeta de circulación </v-btn>
                  <v-btn small center outlined color="blueKonect" class="ma-auto mx-3" elevation="0" @click="showInsurance()"> Póliza de seguro </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 250px; overflow: scroll">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Operador</v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-h6 py-1" v-if="this.items.conductor">
                  Nombre del operador: {{ " " + this.items.conductor.nombre + " " + this.items.conductor.apellido_paterno + " " + this.items.conductor.apellido_materno }}
                </v-card-title>
                <v-card-title class="text-h6 py-1"> Licencias: </v-card-title>
                <v-card-actions style="display: flex; flex-direction: column; align-items: flex-start">
                  <v-btn small center outlined color="blueKonect" class="ma-auto mx-3 mb-3" elevation="0" @click="dialogs.licence = true"> Ver Licencias </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 250px; overflow: scroll">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Calificaciones</v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-h6 py-1"> Promedio de calificaciones: {{ this.items.promedio_calificacion ? this.items.promedio_calificacion : "" }} </v-card-title>
                <v-card-title class="text-h6 py-1"> Detalle de calificación:</v-card-title>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center">Usuario</th>
                        <th class="text-center">Calificación</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, idx) in items.detalle_calificacion" :key="idx">
                        <td class="text-center">{{ `${item.nombre} ${item.apellido_paterno} ${item.apellido_paterno}` }}</td>
                        <td class="text-center">{{ item.calificacion }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 250px; overflow: scroll">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Incidencias</v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-h6" v-if="this.items.incidentes"> {{ this.items.incidentes.length == 0 ? "No hubo incidentes" : "Hubo incidentes." }}</v-card-title>
                <v-card-subtitle></v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 250px; overflow: scroll">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Cancelaciones</v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-h6"> Lista de pasajeros que cancelaron: </v-card-title>
                <v-card-title class="text-h6 pt-0" v-for="item in items.cancelados" :key="item.idviaje_externo">
                  {{ item.usuario.nombre + " " + (item.usuario.apellido_paterno ? item.usuario.apellido_paterno : "") + " " + (item.usuario.apellido_materno ? item.usuario.apellido_materno : "") }}
                </v-card-title>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="rounded-xl elevation-5" style="height: 250px; overflow: scroll">
                <v-toolbar dense dark color="primary" elevation="2">
                  <v-toolbar-title>Pasajeros</v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-h6"> Lista de pasajeros: </v-card-title>
                <v-card-title class="text-h6 pt-0" v-for="item in items.pasajeros" :key="item.idviaje_externo">{{
                  item.nombre + " " + (item.apellido_paterno ? item.apellido_paterno : "") + " " + (item.apellido_materno ? item.apellido_materno : "")
                }}</v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogs.target" persistent max-width="700">
        <v-card>
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title>Tarjeta de circulación</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="loading" text small :loading="loading"></v-btn>
          </v-toolbar>
          <v-card-text v-if="dataTarget">
            <embed :src="'data:application/pdf;base64,' + dataTarget" type="application/pdf" width="100%" height="600px" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="blue-grey" @click="dialogs.target = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.insurance" persistent max-width="700">
        <v-card>
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title>Póliza de seguro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="loading" text small :loading="loading"></v-btn>
          </v-toolbar>
          <v-card-text v-if="this.dataInsurance">
            <p class="mt-5 text-h6"></p>
            <embed :src="'data:application/pdf;base64,' + dataInsurance" type="application/pdf" width="100%" height="600px" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="blue-grey" @click="dialogs.insurance = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.licence" persistent max-width="700">
        <v-card>
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title class="text-h6">Licencias de conductor</v-toolbar-title>
          </v-toolbar>
          <div class="pa-5">
            <div class="text-overline">{{ "Licencia local frente" }}</div>
            <v-img v-if="dataLicence['LICENCIA_LOCAL_FRENTE']" :src="dataLicence['LICENCIA_LOCAL_FRENTE'].path" class="mb-4" contain max-heigth="100" max-width="300"> </v-img>
            <div v-else>{{ "No cuenta con licencia" }}</div>
            <v-divider></v-divider>
            <div class="text-overline">{{ "Licencia local parte trasera" }}</div>
            <v-img v-if="dataLicence['LIENCIA_LOCAL_REVERSO']" :src="dataLicence['LIENCIA_LOCAL_REVERSO'].path" class="mb-4" contain max-heigth="100" max-width="300"> </v-img>
            <div v-else>{{ "No cuenta con licencia" }}</div>
            <v-divider></v-divider>
            <div class="text-overline">{{ "Licencia federal frente" }}</div>
            <v-img v-if="dataLicence['LICENCIA_FEDERAL_FRENTE']" :src="dataLicence['LICENCIA_FEDERAL_FRENTE'].path" class="mb-4" contain max-heigth="100" max-width="300"> </v-img>
            <div v-else>{{ "No cuenta con licencia" }}</div>
            <v-divider></v-divider>
            <div class="text-overline">{{ "Licencia federal parte trasera" }}</div>
            <v-img v-if="dataLicence['LICENCIA_FEDERA_REVERSO']" :src="dataLicence['LICENCIA_FEDERA_REVERSO'].path" class="mb-4" contain max-heigth="100" max-width="300"> </v-img>
            <div v-else>{{ "No cuenta con licencia" }}</div>
            <v-divider></v-divider>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="blue-grey" @click="dialogs.licence = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.map" persistent width="170vh">
        <v-card style="height: 90vh !important">
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title class="text-h6">Mapa de Viaje</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-switch v-model="showRealRoute" color="pinkKonect" label="Ver georuta real" class="mt-5"></v-switch>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="white" @click="dialogs.map = false"> Cerrar </v-btn>
          </v-toolbar>
          <div class="px-4">
            <gmap-map ref="gmap" :center="center" :zoom="zoom" class="mt-6" style="width: 100%; height: 80vh" :options="option">
              <gmap-polyline
                v-for="(p, i) in lineColor"
                :key="p.key"
                v-bind:path="!showRealRoute ? lineColor[i].path : lineColor[i].real_path"
                v-bind:options="{
                  strokeColor: !showRealRoute ? lineColor[i].color : lineColor[i].real_color,
                  strokeOpacity: lineColor[i].opacityLine,
                  strokeWeight: lineColor[i].weight,
                }"
              />
              <gmap-marker
                :key="vehicle.index"
                v-for="vehicle in paradas"
                :position="vehicle"
                :icon="rotateImageVehicle(vehicle)"
                v-on:mouseover="openWindow(vehicle)"
                v-on:mouseout="closeWindow(vehicle)"
              >
                <gmap-info-window v-if="vehicle.dialog == true">
                  <div class="vehicleModal">
                    <p>{{ vehicle.nombre_parada }}</p>
                    <p>{{ vehicle.hora_llegada }}</p>
                  </div>
                </gmap-info-window>
              </gmap-marker>
            </gmap-map>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container v-else>
      <v-card>
        <v-card class="rounded-xl elevation-5">
          <v-toolbar v-if="this.konectVan.item" style="display: flex; justify-content: center" dense dark color="pinkKonect" elevation="2">
            <v-toolbar-title>Detalle de viaje {{ "#" + this.konectVan.item.folio_orden_servicio }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-else>
            <v-row no-gutters class="pb-4" style="justify-content: space-between; align-items: flex-end">
              <v-col>
                <v-card class="rounded-xl elevation-5" style="height: 100%">
                  <v-toolbar dense dark color="primary" elevation="2">
                    <v-toolbar-title>Resumen</v-toolbar-title>
                  </v-toolbar>
                  <div style="height: 150px; overflow: scroll; display: flex">
                    <div class="mt-2" style="width: 50%">
                      <v-card-title class="text-h6 py-1"> {{ "Hubo un error" }} </v-card-title>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-container>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
      {{ errorList[codeError] }}
      {{ "\n\n" + this.codeError }}
    </v-snackbar>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { tablek, errormsg, simpleDialog, infoBtn, csvButton, infoChip } from "@/components";
import moment from "moment";
import errorList from "@/utils/errorsList";
import { mapActions, mapGetters } from "vuex";
import { gmapApi } from "vue2-google-maps";

export default {
  name: "Clientes",
  components: {
    tablek,
    errormsg,
    simpleDialog,
    csvButton,
    infoBtn,
    infoChip,
  },
  data: () => ({
    loading: false,
    success: false,
    msgSuccess: "",
    error: false,
    center: {
      lat: 25.689665,
      lng: -100.310619,
    },
    zoom: 13,
    codeError: "",
    items: [],
    errorList,
    lineColor: [],
    paradas: [],
    option: {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
    },
    estados_viaje: {
      3: "ENVIADO",
      4: "EN CURSO",
      5: "EN CURSO",
      6: "FINALIZADO",
      7: "FINALIZADO",
      8: "CANCELADO",
    },
    showRealRoute: false,
    dataTarget: null,
    dataInsurance: null,
    dataLicence: {},
    dialogs: {
      target: false,
      insurance: false,
      licence: false,
      map: false,
    },
  }),
  activated() {
    this.refresh();
  },
  computed: {
    google: gmapApi,
    ...mapGetters("konectVan", ["konectVan"]),
  },
  methods: {
    ...mapActions("konectVan", ["setComponent"]),
    refresh() {
      this.loading = true;
      let data = {
        idviaje_externo: this.konectVan.item.idviaje_externo,
      };
      this.axios
        .post(services.routes.van + "/report/trip", { data })
        .then((response) => {
          this.items = response.data.data.db;
          this.items.fecha_inicio_plan = moment(this.items.fecha_inicio_plan).format("DD-MM-YYYY HH:mm");
          this.items.fecha_fin_plan = moment(this.items.fecha_fin_plan).format("DD-MM-YYYY HH:mm");
          this.lineColor = [];
          this.lineColor.push({
            path: [],
            real_path: [],
            color: "#1E88E5",
            real_color: "#000000",
          });
          for (let j = 0; j < this.items.info_ruta.georuta.coordinates.length; j++) {
            let obj = { lng: this.items.info_ruta.georuta.coordinates[j][0], lat: this.items.info_ruta.georuta.coordinates[j][1], opacityLine: 1 };
            this.lineColor[0].path.push(obj);
          }
          const real_trip = _.get(this.items, "georuta_real_viaje.coordinates", []);
          for (let j = 0; j < real_trip.length; j++) {
            let obj = { lng: real_trip[j][0], lat: real_trip[j][1], opacityLine: 1 };
            this.lineColor[0].real_path.push(obj);
          }
          this.paradas = [];
          for (let i = 0; i < this.items.info_ruta.paradas.length; i++) {
            let obj = {
              lng: this.items.info_ruta.paradas[i].coordenadas.coordinates[0],
              lat: this.items.info_ruta.paradas[i].coordenadas.coordinates[1],
              nombre_parada: this.items.info_ruta.paradas[i].nombre_parada,
              hora_llegada: moment.utc(this.items.info_ruta.paradas[i].horario.hora_llegada, 'HH:mm:ss').local().format("hh:mm A"),
              dialog: false,
            };
            this.paradas.push(obj);
          }
          const estado_externo = _.get(this.items, "estado_externo", "").toString();
          if (_.has(this.estados_viaje, estado_externo)) {
            this.items.estado_externo = this.estados_viaje[estado_externo];
          } else {
            this.items.estado_externo = "";
          }
          this.items.detalle_calificacion = _.get(this.items, "usuarios_califican", []);
          this.dataLicence = [];
          const arrLicences = _.get(this.items, "conductor.detalle.detalle_conductor.documentos.documentos", []);
          for (let i = 0; i < arrLicences.length; i++) {
            this.dataLicence[arrLicences[i].tipo] = {
              path: process.env.VUE_APP_API_SERVER + "/public-images/licenses/" + arrLicences[i].path,
              ext: arrLicences[i].infoFile.ext,
            };
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.dialogs.statusUser = false;
      this.dialogs.detail = false;
      this.dialogs.licence = false;
      this.dialogs.map = false;
    },
    back() {
      this.setComponent({ component: "home" });
    },
    rotateImageVehicle(date) {
      let data = require("@/assets/marker.png");
      return {
        url: data,
      };
    },
    openWindow(open) {
      open.dialog = true;
    },
    closeWindow(close) {
      close.dialog = false;
    },
    showTarget() {
      this.loading = true;
      this.dataTarget = null;
      this.dialogs.target = true;
      let data = {
        url: "http://viales.apicontrol.be/vialeslegales/" + this.items.vehiculo.numero_economico + "K" + this.items.vehiculo.modelo_chasis.slice(2, 4) + "TJ.pdf",
      };
      this.axios
        .post(services.routes.getFile + "/from/sigue", { data })
        .then((response) => {
          this.dataTarget = response.data.data;
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showInsurance() {
      this.loading = true;
      this.dataInsurance = null;
      this.dialogs.insurance = true;
      let data = {
        url: "http://viales.apicontrol.be/vialeslegales/" + this.items.vehiculo.numero_economico + "K" + this.items.vehiculo.modelo_chasis.slice(2, 4) + "PS.pdf",
      };
      this.axios
        .post(services.routes.getFile + "/from/sigue", { data })
        .then((response) => {
          this.dataInsurance = response.data.data;
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.vehicleModal {
  align-content: center !important;
}
</style>
